import { createContext, useContext } from 'react'
import type { AuthUser } from '@/shared/domain'

type AuthContextValue = {
  user: AuthUser | null
  accessToken: string | null
  isLoading: boolean
  restoreTimedOut?: boolean
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>')
  return ctx
}
